// extracted by mini-css-extract-plugin
export default {"root":"MainWrapper_root__rBv-r","container":"MainWrapper_container__fyq3F"};